import { useEffect, useState } from 'react';

interface AnimatedBarProps {
  /** Target width as a percentage (0–100). */
  percent: number;
  /** Colour / shape classes for the fill, e.g. "h-full bg-primary-500". */
  className?: string;
  /** Transition duration in milliseconds. */
  duration?: number;
}

/**
 * A horizontal bar fill that grows in on mount and glides smoothly to its new
 * width whenever `percent` changes, so live data updates never hard-jump.
 */
function AnimatedBar({ percent, className = '', duration = 700 }: AnimatedBarProps) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const raf = requestAnimationFrame(() => setReady(true));
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <div
      className={`transition-[width] ease-out ${className}`}
      style={{ width: `${ready ? percent : 0}%`, transitionDuration: `${duration}ms` }}
    ></div>
  );
}

export default AnimatedBar;